
/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td

export const tableDetail = {
    entity: 'purchase',//name table on the db
    dest: 'warehousepurchase',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail:`data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"warehousepurchase", "elem":"fullcont", "id":"warehousepurchase-fullcont", "act":"selectOne", "entity":"warehousepurchase", "dbid": "#dbid"}  ],
                                
                                 "clickRight": [{"dest":"warehousepurchase", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"warehousepurchase", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields : ["provider.name","purchase.purchase_date"],
        mainFilterValues : ["", ""],         
        andFilterFields  : [""],
        andFilterValues  : [""],  
    }

}



/****************ELEMENTS*****************/



//each element could organize their data diferent
export function organizeRow(data){ 
    //console.log('organizeRow>')

    var newData = []

    if(data.length === 0){
        newData.push({   id: 'nothing', colum: [{ label:'No Result', span: '' },
                                                { label:'', span: '' },
                                                { label:'', span: '' } ]})
        return newData
    }

    data.forEach((elem)=>{
        
        newData.push(
                {   id: elem.id,   colum: [  { label: elem.providerNameW, span: elem.purchaseCodeREF_tdW,  style:{ 
                                                tdClass:'tdWithAvatar',  
                                                avatar:elem.avatar,
                                                avatarColor: '', 
                                                avatarColorLetter: '', 
                                                avatarLetter: ''  
                                                
                                              } },
                                              { label: elem.purchaseDateW,   span: '' },
                                               
                                        ]    
                }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/